module.exports = __webpack_public_path__ + "baf1f5f97466e1e5832e7e841b9d97a1.svg";